export default "__VITE_ASSET__nxELxnzH__"